import TemplateModel from "./TemplateModel";

export default class TemplateByIdModel extends TemplateModel {
  public adContent: string = null;
}
